/* eslint-disable import/prefer-default-export */
export const actionSuccess = (actionType, response) => ({
  type: actionType,
  response
});
